import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon/Icon';

import styles from './ButtonIcon.module.scss';

const ButtonIcon = ({
  iconName,
  onClick,
  containerStyle,
  iconContainerStyle,
}) => (
  <div
    onClick={onClick}
    className={classnames(styles.container, containerStyle)}
  >
    <Icon
      containerStyle={classnames(styles.iconContainerStyle, iconContainerStyle)}
      name={iconName}
    />
  </div>
);

ButtonIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  containerStyle: PropTypes.any,
  iconContainerStyle: PropTypes.any,
};

ButtonIcon.defaultProps = {
  containerStyle: null,
  iconContainerStyle: null,
};

export default ButtonIcon;
